import Model from '@/models/Model'

export default class HrFamilyAssignment extends Model {
  resource() {
    return 'hr_family_assignment'
  }
}